import React from "react";
import { Route } from "react-router-dom";
import { URL } from "../url";
import LoginScreen from "../../01_Login/login";
import RegisterScreen from "../../01_Register/register";
import ForgotScreen from "../../01_Forgot/forgot";

export const routerPublict = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Route path={URL.home} element={<LoginScreen />} />
      <Route path={URL.register} element={<RegisterScreen />} />
      <Route path={URL.forgot} element={<ForgotScreen />} />
    </>
  );
};
